import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  tap,
  switchMap,
} from 'rxjs/operators';

import {
  CmsPageResponse,
  LayoutParagraphPage,
} from '@digital-platform/rs-cms/domain';
import {
  CmsContentService,
  // CmsPagesService,
} from '@digital-platform/rs-cms/services';
import { MetaDataService } from '@digital-platform/rs-meta/services';

@Component({
  selector: 'digital-platform-cms-page',
  templateUrl: './cms-page.component.html',
  styleUrls: ['./cms-page.component.scss'],
})
export class CmsPageComponent {
  private cmsContentService = inject(CmsContentService);
  // private cmsPagesService = inject(CmsPagesService);
  private metaDataService = inject(MetaDataService);
  private route = inject(ActivatedRoute);

  constructor() {
    // No-op timeout to ensure SSR works correctly. This is a band-aid only
    setTimeout(() => {}, 350);
  }

  // get the page path from the route data and fetch the content from CMS
  private pagePath$: Observable<string> = this.route.data.pipe(
    distinctUntilChanged(),
    map((data) => data['staticContentPath'] || data['pagePath']),
    filter((path) => !!path)
  );

  public pageContent$: Observable<CmsPageResponse['pageContent']> =
    this.pagePath$.pipe(
      switchMap((path) => this.cmsContentService.getPageAsJson(path)),
      tap((page) => {
        const coveoCategory = (page?.pageContent?.[0] as LayoutParagraphPage)
          ?.coveoCategory?.name;
        this.metaDataService.setMetaData({
          ...page?.metatags,
          coveo_category: coveoCategory,
        });
      }),
      map((page) => page?.pageContent || [])
    );
}
